import React from "react";
import { Outlet, useParams } from "react-router-dom";
import { Box, Container, Paper, Tooltip } from "@mui/material";
import { LoadablePage } from "shared/LoadablePage";
import { getUserById } from "client/api/UsersApi";
import { EntityProvider } from "components/EntityProvider/EntityProvider";
import { withTheme } from "components/Theme";
import { RbacPolicies } from "components/authorization/RbacPolicies";
import NavigationSidebarLayout, {
  Navigation,
} from "../../../components/NavigationSidebarLayout/NavigationSidebarLayout";
import useAsyncRequest from "../../../hooks/useAsyncRequest";
import { UserRoutesMap } from "../UserRoutesMap";

export function UserDetailLayout() {
  let { userId } = useParams();
  userId = userId || "UNKNOWN_USER";

  const { data: user, loading, error, refresh } = useAsyncRequest(getUserById, userId ?? "");

  const navLinks = [
    Navigation.navItem("Details", UserRoutesMap.detail(userId).root, true, RbacPolicies.Users.Read),
    Navigation.navItem("Products", UserRoutesMap.detail(userId).products, true, RbacPolicies.Users.Read),
    Navigation.navItem("Audit", UserRoutesMap.detail(userId).audit, true, RbacPolicies.Users.Read),
    Navigation.navItem("Delete", UserRoutesMap.detail(userId).delete, true, RbacPolicies.Users.ReadWrite),
  ];

  const preNavBarContext = (
    <>
      <Tooltip title="User Email">
        <span>{user?.email}</span>
      </Tooltip>
    </>
  );

  return withTheme((theme) => (
    <LoadablePage loading={loading} error={error}>
      <EntityProvider entity={user} refresh={refresh}>
        <NavigationSidebarLayout
          navLinks={navLinks}
          name={user ? `${user?.firstName} ${user?.lastName ?? ""}` : "User"}
          preNavbarComponent={preNavBarContext}
        >
          <Container maxWidth={false} disableGutters={true}>
            <Paper>
              <Box
                sx={{
                  padding: 2,
                }}
              >
                <Outlet />
              </Box>
            </Paper>
          </Container>
        </NavigationSidebarLayout>
      </EntityProvider>
    </LoadablePage>
  ));
}
